/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  personalizedFollowUps(conversationID, payload) {
    return axios.post(`${this.url}/${conversationID}/personalized_follow_ups`, payload);
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  scheduleProactiveFollowUp(conversationID) {
    return axios.post(
      `${this.url}/${conversationID}/schedule_proactive_follow_up`
    );
  }

  getProactiveFollowUpInboxes() {
    return axios.get(`${this.url}/proactive_follow_up_inboxes`);
  }

  getProactiveFollowUps(conversationID) {
    return axios.get(`${this.url}/${conversationID}/proactive_follow_ups`);
  }

  cancelProactiveFollowUp(conversationID, pfuId) {
    return axios.delete(
      `${this.url}/${conversationID}/proactive_follow_ups/${pfuId}`
    );
  }
}

export default new ConversationApi();
